import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
  wrapper: {
    margin: "1px",
    position: "relative",
  },
  centerLabel: {
    "& .MuiInputLabel-root": {
      top: "-3px"
    }
  },
  accordionRoot: {
    boxShadow: 'none !important',
    borderTop: '1px solid #F1F0F5',
    borderBottom: '1px solid #F1F0F5',
    '&::before': {
      backgroundColor: 'transparent !important'
    },
    '&.Mui-expanded': {
      margin: '0 !important'
    },
    '&.Mui-disabled': {
      backgroundColor: '#ffffff !important'
    }
  },
  personalInfo: {
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "22px",
    color: "#14142B",
    fontFamily: "Open Sans",
    fontSize: "18px",
    marginBottom: "28px",
  },
  continueBtn: {
    color: "#fff !important",
    background: "rgba(57, 162, 219, 1) !important",
    borderRadius: "24px !important",
    padding: "9px 17px !important",
    height: "49px",
    '&.Mui-disabled': {
      background: "rgba(211, 211, 211, 1) !important",
    }
  },
  continueBtnText: {
    textTransform: "capitalize",
    fontSize: '18px !important',
    lineHeight: '22px !important',
    fontWeight: '700 !important',
    fontFamily: "Work Sans !important",
  },
  finishLaterBtnWrapper: {
    margin: "1px",
    marginBottom: "40px",
    position: "relative",
  },
  finishLaterBtn: {
    borderRadius: "24px !important", 
    border: "1px solid #39A2DB !important",
    padding: "9px 17px !important",
    height: "49px !important", 
  },
  finishLaterBtnText: {
    textTransform: "capitalize",
    fontFamily: 'Work Sans !important',
    fontStyle: 'normal !important',
    fontWeight: '600 !important',
    fontSize: '18px !important',
    lineHeight: '22px !important',
    color: '#39A2DB !important',
  },
  radio: {
    color: '#D9D9D9 !important',
    '&.Mui-checked': {
      color: '#39A2DB !important',
    }
  },
  buttonProgress: {
    color: "#39A2DB",
    position: "absolute",
    top: "12px",
    left: "calc( 50% - 13px )",
  },
}));
